

import {useStore} from 'vuex'
import {defineComponent, PropType, ref, watch} from 'vue'
import Directr, {ContentType} from '@/services/directr'
import LabelBox from '@/pages/Products/components/LabelBox.vue'

type Packing = {
  name: string,
  sys: {
    id: string,
    type: 'packing' | 'category',
  },
  type: string | null
}

type PackingGroup = {
  group: string;
  children: string[];
}

export default defineComponent({
  name: 'PackingTable',
  components: {LabelBox},
  props: {
    packing: {
      type: Array as PropType<Packing[]>
    }
  },
  setup (props) {
    const $store = useStore()
    const $directr: Directr = $store.getters['Services/Directr']
    const packingGroups = ref<PackingGroup[]>([])

    const getCategoryChildren = async (categoryId): Promise<Packing[]> => {
      return await $directr.get(ContentType.Packing, [{
        where:
          {
            and: [
              {not: [{categories: null}]},
              {[`'${ categoryId }'`]: { any: 'categories' }}
            ]
          }
      }], { orm: true }).then(({ items = [] }) => items)
    }
    const getPackingGroups = async () => {
      if (!props.packing?.length) {
        packingGroups.value = []
        return
      }

      const defaultGroup = {
        group: 'Custom',
        children: props.packing.filter(p => p.sys?.type === 'packing').map(p => p.name)
      }

      const categories = await Promise.all(props.packing.filter(p => p.sys.type === 'category').map(async p => ({ group: p.name, children: (await getCategoryChildren(p.sys.id)).map(p => p.name) })))

      packingGroups.value = [
        defaultGroup,
        ...categories
      ]
    }

    void getPackingGroups()

    watch(() => [props.packing], getPackingGroups)

    return {
      packingGroups
    }
  }
})
